import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
	period: Yup.string().required().oneOf(['daily', 'weekly', 'monthly']).label('Period'),
});

const Inputs = [
	{
		name: 'period',
		label: 'Players of Period',
		type: 'selectCustom',
		value: 'single',
		valueAttr: 'period',
		customOptions: () => [
			{ id: 'daily', name: 'Last Day (yesterday)' },
			{ id: 'weekly', name: 'Last 7 Days' },
			{ id: 'monthly', name: 'Last 30 Days' },
		],
		required: true,
	},
	{
		name: 'computeActions',
		label: 'Manual Compute',
		type: 'apiButtons',
		buttons: [
			{
				key: 'compute',
				label: 'Compute Players Now',
				endpoint: 'api/AdminGeneralSettings/ComputePlayersOfPeriod',
				method: 'POST',
				confirmMessage: 'Are you sure you want to recompute players of period?',
				successMessage: 'Players of period computed successfully!',
			},
		],
	},
];

export { Inputs, validationSchema };
